/**
 * @name Global Reducer
 * @memberof module:common/reducers
 * @type {ReduxReducer}
 * @return {Object} Reducer Specification
 */

import { setAllocationInfo } from './reducer';
import { SET_ALLOCATION_INFO } from '../../actions/allocations/types';

export default {
  [SET_ALLOCATION_INFO]: setAllocationInfo,
};
